import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const clubBoatLeftToRightPath: PathObjectInterface = {
  mainPath: { x: 3969, y: 1914 },
  spline: [
    3969, 1914, 3309, 1921, 2582, 1907, 1994, 1897, 1202, 1808, 770, 1631, 595, 1396, 571, 1211,
    643, 1052, 743, 966, 907, 798, 1005, 724, 1175, 685, 1384, 640, 1617, 652, 1838, 649, 1948, 584,
  ],
}
